<template>
    <v-dialog :value="dialog" max-width="1300px" persistent @keydown.esc="chiudiDialog()">
        <v-card>
            <v-card-title class="headline">
                <v-col>
                    <v-row>
                        Declassamento materiale a magazzino
                        <v-spacer />
                        <v-btn icon @click="chiudiDialog()">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-row>
                    <v-row>
                        <small>Nota: solo le righe selezionate ed evidenziate di rosso verranno declassate</small>
                        <v-spacer />
                        <v-text-field v-model="search" append-icon="search" label="Cerca" single-line clearable />
                        <v-btn icon @click="caricaDati()" class="ml-2 mt-4">
                            <v-icon>refresh</v-icon>
                        </v-btn>
                    </v-row>
                </v-col>
            </v-card-title>

            <v-card-text>
                <v-data-table :items="elencoMateriali" :headers="headersMateriali" :items-per-page="-1"
                    hide-default-footer height="500" fixed-header show-select v-model="righeSelezionate"
                    item-key="idMateriale" :search="search" mobile-breakpoint="0"
                    no-data-text="Nessun materiale a magazzino">
                    <template v-slot:item.qtaRimanente="{ item }">
                        {{ arrotonda(item.qtaRimanente) }}
                    </template>
                    <template v-slot:item.qtaDaDeclassare="{ item }">
                        <v-text-field v-model.number="item.qtaDaDeclassare" type="number" dense hide-details min="0"
                            :max="item.qtaRimanente" step="any" style="width: 110px"
                            @change="controllaQuantita(item)" />
                    </template>
                    <template v-slot:item.dataConsumo="{ item }">
                        <v-text-field v-model="item.dataConsumo" type="date" dense hide-details
                            style="width: 150px" />
                    </template>
                </v-data-table>

            </v-card-text>

            <v-card-actions>
                <v-btn color="primary" @click="apriDialogStorico()">
                    <v-icon small class="mr-2">manage_history</v-icon>visualizza storico</v-btn>
                <v-spacer />
                <v-btn @click="chiudiDialog()">Chiudi</v-btn>
                <v-btn color="primary" @click="salvaDati" :disabled="salvataggioInCorso"
                    :loading="salvataggioInCorso">Salva</v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog v-model="dialogStorico" max-width="1300px">
            <v-card>
                <v-card-title class="headline">
                    <v-col>
                        <v-row>
                            Storico declassamento
                            <v-spacer />
                            <v-btn icon @click="chiudiStorico()">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-row>
                        <v-row>
                            <v-spacer />
                            <v-text-field v-model="searchStorico" append-icon="search" label="Cerca" single-line
                                clearable />
                            <v-btn icon @click="caricaStorico()" class="ml-2 mt-4">
                                <v-icon>refresh</v-icon>
                            </v-btn>
                        </v-row>
                    </v-col>
                </v-card-title>
                <v-card-text>
                    <v-data-table :headers="headersStorico" :items="datiStorico" item-key="chiave" fixed-header
                        :items-per-page="-1" height="500" no-data-text="Nessun dato disponibile" hide-default-footer
                        :search="searchStorico" mobile-breakpoint="0">
                        <template v-slot:item.qtaDaDeclassare="{ item }">
                            <v-text-field v-model.number="item.qtaDaDeclassare" type="number" dense hide-details
                                min="0" :max="item.qtaOriginale" step="any" style="width: 110px"
                                @change="modificaQuantitaStorico(item)" />
                        </template>

                        <template v-slot:item.azioni="{ item }">
                            <v-btn icon @click="eliminaElemento(item)"><v-icon>delete</v-icon></v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn @click="chiudiStorico()">Chiudi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>

<script>

import { get_materiali_disponibili, salva_declassamento, get_storico_declassamento, salva_storico_declassamento } from '@/api/api.registroSintesiPers.js'

export default {
    props: {
        dialog: { type: Boolean, default: false },
        compCode: { type: String, default: '' },
        variante: { type: String, default: '' },
    },

    data() {
        return {
            elencoMateriali: [],
            righeSelezionate: [],
            salvataggioInCorso: false,

            // True se dall'apertura del dialog è stato scritto qualcosa sul server: il padre deve ricaricare i dati
            modificato: false,
            // True se lo storico è stato modificato dopo l'ultimo caricamento dei materiali disponibili
            storicoModificato: false,

            dialogStorico: false,
            datiStorico: [],

            search: "",
            searchStorico: "",
        }
    },

    methods: {
        chiudiDialog(salva = false) {
            this.$emit("close", salva || this.modificato);
        },

        oggi() {
            // Data locale (toISOString darebbe la data UTC, sbagliata tra mezzanotte e le 2)
            const d = new Date();
            return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
        },

        arrotonda(valore) {
            return Math.round(valore * 1000) / 1000;
        },

        async caricaDati() {
            this.righeSelezionate = [];
            this.storicoModificato = false;

            try {
                const res = await get_materiali_disponibili(this.par);
                const oggi = this.oggi();

                // I campi locali devono esistere subito per essere reattivi
                this.elencoMateriali = res.data
                    .filter(item => item.qtaRimanente > 0)
                    .map(item => ({ ...item, qtaDaDeclassare: 0, dataConsumo: oggi }));
            } catch (error) {
                console.error("Errore durante il caricamento dei materiali:", error);
                this.$toast.error("Errore durante il caricamento dei materiali");
            }
        },

        async salvaDati() {
            if (this.righeSelezionate.length <= 0) {
                this.$toast.alert("Attenzione. Nessuna riga selezionata")
                return;
            }

            const righeDaSalvare = this.righeSelezionate
                .map(item => ({
                    companyCode: this.compCode,
                    idMateriale: item.idMateriale,
                    // Il server controlla comunque la giacenza: qui si evita solo di superarla per un valore digitato e non confermato
                    qtaDaDeclassare: Math.min(Number(item.qtaDaDeclassare) || 0, item.qtaRimanente),
                    dataConsumo: item.dataConsumo || this.oggi(),
                }))
                .filter(riga => riga.qtaDaDeclassare > 0);

            if (righeDaSalvare.length <= 0) {
                this.$toast.alert("Attenzione. Indicare la quantità da declassare per almeno una riga selezionata")
                return;
            }

            this.salvataggioInCorso = true;
            try {
                const res = await salva_declassamento(righeDaSalvare);
                if (res.data === "OK") {
                    this.modificato = true;
                    this.chiudiDialog(true);
                }
                else this.$toast.alert(res.data);
            } catch (error) {
                console.error("Errore durante il salvataggio del declassamento:", error);
                this.$toast.error("Errore durante il salvataggio del declassamento");
            } finally {
                this.salvataggioInCorso = false;
            }
        },

        controllaQuantita(item) {
            const qta = Number(item.qtaDaDeclassare);
            if (!(qta > 0)) {
                item.qtaDaDeclassare = 0;
            } else if (qta > item.qtaRimanente) {
                item.qtaDaDeclassare = item.qtaRimanente;
            }
        },

        apriDialogStorico() {
            this.dialogStorico = true;
            this.caricaStorico();
        },

        async caricaStorico() {
            try {
                const res = await get_storico_declassamento(this.par);
                // La chiave di riga serve al data-table: lo storico non ha un campo id univoco
                this.datiStorico = res.data.map(item => ({ ...item, chiave: item.idMateriale + "-" + item.prog }));
            } catch (error) {
                console.error("Errore durante il caricamento dello storico:", error);
                this.$toast.error("Errore durante il caricamento dello storico");
            }
        },

        // Salva solo su @change (a campo confermato): ogni salvataggio è una scrittura sul server
        async modificaQuantitaStorico(item) {
            let qta = Number(item.qtaDaDeclassare);

            if (!(qta > 0)) {
                this.$toast.alert("La quantità da declassare deve essere maggiore di zero");
                this.caricaStorico();   // ripristina il valore salvato
                return;
            }
            if (qta > item.qtaOriginale) {
                qta = item.qtaOriginale;
                item.qtaDaDeclassare = qta;
            }

            try {
                const res = await salva_storico_declassamento({
                    companyCode: this.compCode,
                    idMateriale: item.idMateriale,
                    prog: item.prog,
                    qtaDaDeclassare: qta,
                }, "post");

                if (res.data === "OK") {
                    this.modificato = true;
                    this.storicoModificato = true;
                } else {
                    this.$toast.alert(res.data);
                    this.caricaStorico();
                }
            } catch (error) {
                console.error("Errore durante la modifica del declassamento:", error);
                this.$toast.error("Errore durante la modifica del declassamento");
                this.caricaStorico();
            }
        },

        async eliminaElemento(item) {
            const confirm = await this.$confirm.open("Elimina", "Eliminare l'elemento?");
            if (!confirm) return;

            try {
                const res = await salva_storico_declassamento({
                    companyCode: this.compCode,
                    idMateriale: item.idMateriale,
                    prog: item.prog,
                }, "delete");

                if (res.data !== "OK") {
                    this.$toast.alert(res.data);
                } else {
                    this.modificato = true;
                    this.caricaStorico();
                    this.caricaDati();
                }
            } catch (error) {
                console.error("Errore durante l'eliminazione del declassamento:", error);
                this.$toast.error("Errore durante l'eliminazione del declassamento");
            }
        },

        chiudiStorico() {
            this.dialogStorico = false;
            // Le quantità modificate nello storico cambiano la giacenza: aggiorna l'elenco principale
            if (this.storicoModificato) this.caricaDati();
        },
    },

    watch: {
        dialog: {
            handler(newVal) {
                if (!newVal) return;
                this.modificato = false;
                this.caricaDati();
            },
            immediate: true
        },
    },

    computed: {
        role() {
            return this.$store.getters['user/getRole'];
        },

        // Querystring per le letture: un utente cliente opera sempre sulla propria azienda
        par() {
            return this.role !== "utente" ? "?companyCode=" + this.compCode : "";
        },

        isLegno() {
            return this.variante === 'LEGNO';
        },

        headersMateriali() {
            return [
                { text: "Gruppo", value: "codGruppoCategoriaFSC" },
                ...(this.isLegno ? [{ text: "Essenza", value: "essenza" }] : []),
                { text: "Fornitore", value: "fornitore" },
                { text: "DDT", value: "nBollaText" },
                { text: "Descrizione", value: "descrizione" },
                { text: "Quantità a magazzino", value: "qtaRimanente" },
                { text: "Quantità da declassare", value: "qtaDaDeclassare", sortable: false },
                { text: "UM", value: "um" },
                { text: "Data", value: "dataConsumo", sortable: false },
            ];
        },

        headersStorico() {
            return [
                { text: "Gruppo", value: "gruppoCategoriaFSC" },
                ...(this.isLegno ? [{ text: "Essenza", value: "essenza" }] : []),
                { text: "Fornitore", value: "fornitore" },
                { text: "DDT", value: "nBollaText" },
                { text: "Descrizione", value: "descrizione" },
                { text: "Quantità declassata", value: "qtaDaDeclassare", sortable: false },
                { text: "UM", value: "um" },
                { text: "Data declassamento", value: "dataConsumoIT" },
                { text: "Azioni", value: "azioni", sortable: false },
            ];
        },
    }
}
</script>
<style scoped>
/* usare ::v-deep per raggiungere elementi figli fuori dallo scope */
::v-deep .v-data-table__selected {
    background-color: #e7d1d6 !important;
    /* sfondo */
    transition: background-color 0.2s ease;
}

::v-deep .v-data-table__selected td {
    color: #30181f !important;
    /* colore testo */
}
</style>
